import { AuthLinkButton, AuthLinks } from '../../authModal.styles';
import { AUTH_STEPS } from '../constants/authForm.constants';

const AuthFormStepLinks = ({
	currentStep,
	onGoBack,
	onForgotPassword,
	translations,
}) => {
	const showLinks =
		currentStep === AUTH_STEPS.PASSWORD_LOGIN ||
		currentStep === AUTH_STEPS.PASSWORD_SET ||
		currentStep === AUTH_STEPS.PASSWORD_REGISTER;

	if (!showLinks) {
		return null;
	}

	return (
		<AuthLinks>
			<AuthLinkButton onClick={onGoBack} type="button">
				{translations.goBackLink || 'Change Email'}
			</AuthLinkButton>
			{currentStep === AUTH_STEPS.PASSWORD_LOGIN && (
				<AuthLinkButton onClick={onForgotPassword} type="button">
					{translations.forgotPasswordLink || 'Forgot password?'}
				</AuthLinkButton>
			)}
		</AuthLinks>
	);
};

export default AuthFormStepLinks;
